import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@shared/ui/dialog";
import { Button } from "@shared/ui/button";
import { Label } from "@shared/ui/label";
import { Badge } from "@shared/ui/badge";
interface FAQ {
  id: string;
  question: string;
  answer: string;
  category: string;
  utility: string;
  status: "active" | "inactive";
  order: number;
}

interface FAQDetailViewProps {
  faq: FAQ | null;
  isOpen: boolean;
  onClose: () => void;
}

export const FAQDetailView = ({ faq, isOpen, onClose }: FAQDetailViewProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>FAQ Details</DialogTitle>
          <DialogDescription>
            View the complete FAQ information below.
          </DialogDescription>
        </DialogHeader>
        {faq && (
          <div className="space-y-4">
            <div>
              <Label className="text-sm font-medium">Question</Label>
              <p className="mt-1 text-sm text-muted-foreground">{faq.question}</p>
            </div>
            <div>
              <Label className="text-sm font-medium">Answer</Label>
              <p className="mt-1 text-sm text-muted-foreground whitespace-pre-wrap">{faq.answer}</p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-sm font-medium">Utility</Label>
                <p className="mt-1 text-sm text-muted-foreground">{faq.utility}</p>
              </div>
              <div>
                <Label className="text-sm font-medium">Category</Label>
                <p className="mt-1 text-sm text-muted-foreground">{faq.category}</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-sm font-medium">Status</Label>
                <div className="mt-1">
                  <Badge variant={faq.status === "active" ? "default" : "secondary"}>
                    {faq.status}
                  </Badge>
                </div>
              </div>
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
